/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AccountBadgeAdminPanelGroupSwitcherQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type AccountBadgeAdminPanelGroupSwitcherQuery = {
  __typename?: 'Query'
  groups: Array<{
    __typename?: 'BackofficeUserManagementGroup'
    name: string
    displayName: string
    assignedOrganizations: Array<string> | null
  }> | null
}

export type SwitchAdminPanelGroupMutationVariables = Types.Exact<{
  input: Types.AdminPanelSwapGroupInput
}>

export type SwitchAdminPanelGroupMutation = {
  __typename?: 'Mutation'
  adminPanelSwapGroup: {
    __typename?: 'BackofficeUser'
    id: string
    adminPanelTimedGroups: Array<{
      __typename?: 'BackofficeUserTimeGroup'
      groupName: string
      displayName: string | null
      expires: string | null
    }> | null
  }
}

export const AccountBadgeAdminPanelGroupSwitcherDocument = gql`
    query AccountBadgeAdminPanelGroupSwitcher {
  groups: adminPanelGroups {
    name
    displayName
    assignedOrganizations
  }
}
    `

/**
 * __useAccountBadgeAdminPanelGroupSwitcherQuery__
 *
 * To run a query within a React component, call `useAccountBadgeAdminPanelGroupSwitcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBadgeAdminPanelGroupSwitcherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBadgeAdminPanelGroupSwitcherQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountBadgeAdminPanelGroupSwitcherQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountBadgeAdminPanelGroupSwitcherQuery,
    AccountBadgeAdminPanelGroupSwitcherQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AccountBadgeAdminPanelGroupSwitcherQuery,
    AccountBadgeAdminPanelGroupSwitcherQueryVariables
  >(AccountBadgeAdminPanelGroupSwitcherDocument, options)
}
export function useAccountBadgeAdminPanelGroupSwitcherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountBadgeAdminPanelGroupSwitcherQuery,
    AccountBadgeAdminPanelGroupSwitcherQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AccountBadgeAdminPanelGroupSwitcherQuery,
    AccountBadgeAdminPanelGroupSwitcherQueryVariables
  >(AccountBadgeAdminPanelGroupSwitcherDocument, options)
}
// @ts-ignore
export function useAccountBadgeAdminPanelGroupSwitcherSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccountBadgeAdminPanelGroupSwitcherQuery,
    AccountBadgeAdminPanelGroupSwitcherQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AccountBadgeAdminPanelGroupSwitcherQuery,
  AccountBadgeAdminPanelGroupSwitcherQueryVariables
>
export function useAccountBadgeAdminPanelGroupSwitcherSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountBadgeAdminPanelGroupSwitcherQuery,
        AccountBadgeAdminPanelGroupSwitcherQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AccountBadgeAdminPanelGroupSwitcherQuery | undefined,
  AccountBadgeAdminPanelGroupSwitcherQueryVariables
>
export function useAccountBadgeAdminPanelGroupSwitcherSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountBadgeAdminPanelGroupSwitcherQuery,
        AccountBadgeAdminPanelGroupSwitcherQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AccountBadgeAdminPanelGroupSwitcherQuery,
    AccountBadgeAdminPanelGroupSwitcherQueryVariables
  >(AccountBadgeAdminPanelGroupSwitcherDocument, options)
}
export type AccountBadgeAdminPanelGroupSwitcherQueryHookResult = ReturnType<
  typeof useAccountBadgeAdminPanelGroupSwitcherQuery
>
export type AccountBadgeAdminPanelGroupSwitcherLazyQueryHookResult = ReturnType<
  typeof useAccountBadgeAdminPanelGroupSwitcherLazyQuery
>
export type AccountBadgeAdminPanelGroupSwitcherSuspenseQueryHookResult =
  ReturnType<typeof useAccountBadgeAdminPanelGroupSwitcherSuspenseQuery>
export type AccountBadgeAdminPanelGroupSwitcherQueryResult = Apollo.QueryResult<
  AccountBadgeAdminPanelGroupSwitcherQuery,
  AccountBadgeAdminPanelGroupSwitcherQueryVariables
>
export const SwitchAdminPanelGroupDocument = gql`
    mutation SwitchAdminPanelGroup($input: AdminPanelSwapGroupInput!) {
  adminPanelSwapGroup(input: $input) {
    id
    adminPanelTimedGroups {
      groupName
      displayName
      expires
    }
  }
}
    `
export type SwitchAdminPanelGroupMutationFn = Apollo.MutationFunction<
  SwitchAdminPanelGroupMutation,
  SwitchAdminPanelGroupMutationVariables
>

/**
 * __useSwitchAdminPanelGroupMutation__
 *
 * To run a mutation, you first call `useSwitchAdminPanelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchAdminPanelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchAdminPanelGroupMutation, { data, loading, error }] = useSwitchAdminPanelGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchAdminPanelGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SwitchAdminPanelGroupMutation,
    SwitchAdminPanelGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SwitchAdminPanelGroupMutation,
    SwitchAdminPanelGroupMutationVariables
  >(SwitchAdminPanelGroupDocument, options)
}
export type SwitchAdminPanelGroupMutationHookResult = ReturnType<
  typeof useSwitchAdminPanelGroupMutation
>
export type SwitchAdminPanelGroupMutationResult =
  Apollo.MutationResult<SwitchAdminPanelGroupMutation>
export type SwitchAdminPanelGroupMutationOptions = Apollo.BaseMutationOptions<
  SwitchAdminPanelGroupMutation,
  SwitchAdminPanelGroupMutationVariables
>
